import React, { useMemo } from 'react';

import { NavigationAnalyticsContext } from '@atlaskit/analytics-namespaced-context';

import { COMPONENT_NAME } from '../common/analytics/constants';
import { type PackageMetaDataType } from '../common/analytics/generated/analytics.types';
import type { GlobalSideNavigationProps } from '../common/types';

import { GlobalSideNavigationWithLocalStore } from './side-nav/GlobalSideNavWithLocalStore';
import { GlobalSideNavigationWithNetworkStore } from './side-nav/GlobalSideNavWithNetworkStore';

const PACKAGE_DATA: PackageMetaDataType = {
	componentName: COMPONENT_NAME,
	packageName: process.env._PACKAGE_NAME_ ?? '',
	packageVersion: process.env._PACKAGE_VERSION_ ?? '',
};

export function GlobalSideNavigation(props: GlobalSideNavigationProps) {
	const { customizationStore = 'local', ...innerProps } = props;

	const SideNav = useMemo(() => {
		return customizationStore === 'local'
			? GlobalSideNavigationWithLocalStore
			: GlobalSideNavigationWithNetworkStore;
	}, [customizationStore]);

	return (
		<NavigationAnalyticsContext
			data={{
				...PACKAGE_DATA,
				source: 'topNav',
				product: props.app,
				attributes: {
					navVersion: '4',
					navLayer: 'global',
					navContainer: 'top',
					screen: props.app,
					workspaceUuid: null,
				},
			}}
		>
			<SideNav {...innerProps} />
		</NavigationAnalyticsContext>
	);
}
